/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Init_Data_By_Bms_ModuleInputs */



/**
* | output |
* | --- |
* | "Initialize data by BMS module" |
*
* @param {Init_Data_By_Bms_ModuleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const init_data_by_bms_module = /** @type {((inputs?: Init_Data_By_Bms_ModuleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Init_Data_By_Bms_ModuleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Initialize data by BMS module")
	return /** @type {LocalizedString} */ ("Initialiser les données par module GTB")
});